<template>
  <b-form-group
    label="E-Posta"
    :label-for="'email_' + itemKey"
  >

    <b-form-input
      :id="'email_' + itemKey"
      v-model="dataItem.related_persons[itemKey].email"
      placeholder="E-Posta"
    />

  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  name: 'Name',
  components: {
    ValidationProvider,
    BFormGroup,
    BFormInput,
  },
  props: {
    itemKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
